import React, { useEffect, useState } from 'react';
import LoginContainer from '../../containers/LoginContainer/LoginContainer';
import SplashScreenContainer from '../../containers/LoginContainer/SplashScreenContainer';

type Props = {};

const LoginPage = (props: Props) => {
    console.log(props);
    const [showSplashScreen, setShowSplashScreen] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSplashScreen(false);
        }, 750);
        return () => clearTimeout(timer);
    }, []);

    return (
        showSplashScreen ?
            <SplashScreenContainer /> :
            <LoginContainer />

    );
};

export default LoginPage;
